import { Alert, Link, VerticalSpace } from '@elhub/ds-components'
import { ExitToApp as ExternalLinkIcon } from '@elhub/ds-icons/dist/ExitToApp'

import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { ApiMessages } from '../../locales/messages/api'

export interface EnergyDataProps {
  children?: ReactNode
}

const EnergyData = ({ children }: EnergyDataProps) => {
  const { t } = useTranslation()

  return (
    <>
      {children}
      <VerticalSpace />
      <Alert variant='info'>
        {t(ApiMessages.ENERGY_DATA_PARAGRAPH_INFO_1 as any)}{' '}
        <Link href='//jsonapi.org'>
          {t(ApiMessages.ENERGY_DATA_PARAGRAPH_INFO_2 as any)} <ExternalLinkIcon size='1.5rem' />
        </Link>{' '}
        {t(ApiMessages.ENERGY_DATA_PARAGRAPH_INFO_3 as any)}
      </Alert>
      <VerticalSpace />
      <Alert variant='warning'>{t(ApiMessages.ENERGY_DATA_PARAGRAPH_WARNING_1 as any)}</Alert>
      <VerticalSpace />
    </>
  )
}

export default EnergyData
